import { SET_ALERT, SET_ALERT_VISIBILITY } from "./types";

export const setAlert = (alertContent, alertVariant) => dispatch => {
  dispatch(
    {
      type: SET_ALERT,
      payload: {
        alertContent: alertContent,
        alertVariant: alertVariant
      }
    }
  );
  dispatch({
    type: SET_ALERT_VISIBILITY,
    payload: true
  });
};

export const setAlertVisibility = toggle => dispatch => {
  dispatch({
    type: SET_ALERT_VISIBILITY,
    payload: toggle
  });
};
